import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/home/runner/work/ass/ass/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.array.map";
import { parseDrawing } from './drawing.js';
var numTags = ['b', 'i', 'u', 's', 'fsp', 'k', 'K', 'kf', 'ko', 'kt', 'fe', 'q', 'p', 'pbo', 'a', 'an', 'fscx', 'fscy', 'fax', 'fay', 'frx', 'fry', 'frz', 'fr', 'be', 'blur', 'bord', 'xbord', 'ybord', 'shad', 'xshad', 'yshad'];
var numRegexs = numTags.map(function (nt) {
  return {
    name: nt,
    regex: new RegExp("^".concat(nt, "-?\\d"))
  };
});
export function parseTag(text) {
  var tag = {};
  for (var i = 0; i < numRegexs.length; i++) {
    var _numRegexs$i = numRegexs[i],
      name = _numRegexs$i.name,
      regex = _numRegexs$i.regex;
    if (regex.test(text)) {
      tag[name] = text.slice(name.length) * 1;
      return tag;
    }
  }
  if (/^fn/.test(text)) {
    tag.fn = text.slice(2);
  } else if (/^r/.test(text)) {
    tag.r = text.slice(1);
  } else if (/^fs[\d+-]/.test(text)) {
    tag.fs = text.slice(2);
  } else if (/^\d?c&?H?[0-9a-f]+|^\d?c$/i.test(text)) {
    var _text$match = text.match(/^(\d?)c&?H?(\w*)/),
      _text$match2 = _slicedToArray(_text$match, 3),
      num = _text$match2[1],
      color = _text$match2[2];
    tag["c".concat(num || 1)] = color && "000000".concat(color).slice(-6);
  } else if (/^\da&?H?[0-9a-f]+/i.test(text)) {
    var _text$match3 = text.match(/^(\d)a&?H?(\w\w)/),
      _text$match4 = _slicedToArray(_text$match3, 3),
      _num = _text$match4[1],
      alpha = _text$match4[2];
    tag["a".concat(_num)] = alpha;
  } else if (/^alpha&?H?[0-9a-f]+/i.test(text)) {
    var _text$match5 = text.match(/^alpha&?H?([0-9a-f]+)/i);
    var _text$match6 = _slicedToArray(_text$match5, 2);
    tag.alpha = _text$match6[1];
    tag.alpha = "00".concat(tag.alpha).slice(-2);
  } else if (/^(?:pos|org|move|fad|fade)\(/.test(text)) {
    var _text$match7 = text.match(/^(\w+)\((.*?)\)?$/),
      _text$match8 = _slicedToArray(_text$match7, 3),
      key = _text$match8[1],
      value = _text$match8[2];
    tag[key] = value.trim().split(/\s*,\s*/).map(Number);
  } else if (/^i?clip/.test(text)) {
    var p = text.match(/^i?clip\((.*?)\)?$/)[1].trim().split(/\s*,\s*/);
    tag.clip = {
      inverse: /iclip/.test(text),
      scale: 1,
      drawing: null,
      dots: null
    };
    if (p.length === 1) {
      tag.clip.drawing = parseDrawing(p[0]);
    }
    if (p.length === 2) {
      tag.clip.scale = p[0] * 1;
      tag.clip.drawing = parseDrawing(p[1]);
    }
    if (p.length === 4) {
      tag.clip.dots = p.map(Number);
    }
  } else if (/^t\(/.test(text)) {
    var _p = text.match(/^t\((.*?)\)?$/)[1].trim().replace(/\\.*/, function (x) {
      return x.replace(/,/g, '\n');
    }).split(/\s*,\s*/);
    if (!_p[0]) return tag;
    tag.t = {
      t1: 0,
      t2: 0,
      accel: 1,
      tags: _p[_p.length - 1].replace(/\n/g, ',').split('\\').slice(1).map(parseTag)
    };
    if (_p.length === 2) {
      tag.t.accel = _p[0] * 1;
    }
    if (_p.length === 3) {
      tag.t.t1 = _p[0] * 1;
      tag.t.t2 = _p[1] * 1;
    }
    if (_p.length === 4) {
      tag.t.t1 = _p[0] * 1;
      tag.t.t2 = _p[1] * 1;
      tag.t.accel = _p[2] * 1;
    }
  }
  return tag;
}